import { useQuery } from "react-query";
import { getEmployees } from "../../../../../actions/Employees";

export const useEmployees = () => {
  return useQuery("GetEmployees", getEmployees, {
    refetchOnWindowFocus: false,
  });
};
